import React from 'react';
import PropTypes from 'prop-types';
import './Card.scss';

const Card = ({
    id = '',
    title,
    body,
    footer,
    className = '',
    bodyClassName = '',
    allowOverflow = false,
}) => {
    const classes = ['card'];
    const bodyClasses = ['card-body'];

    if (className) {
        classes.push(className);
    }
    if (bodyClassName) {
        bodyClasses.push(bodyClassName);
    }
    if (allowOverflow) {
        classes.push('card--allow-overflow');
    }

    return (
        <div {...(id ? { id } : {})} className={classes.join(' ')}>
            <div className="card-header">{title}</div>
            <div className={bodyClasses.join(' ')}>{body}</div>
            <div className="card-footer">{footer}</div>
        </div>
    );
};

Card.propTypes = {
    id: PropTypes.string,
    title: PropTypes.node.isRequired,
    body: PropTypes.node.isRequired,
    footer: PropTypes.node.isRequired,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    allowOverflow: PropTypes.bool,
};

export default Card;
